
(function () {
  'use strict';

  var script = document.currentScript;
  if (!script) return;

  var PRODUCT_ID = script.getAttribute('data-product-id') || '';
  var PRODUCT_NAME = script.getAttribute('data-product-name') || '';

  var WIDGET_SELECTOR = '#sm-widget-btn';
  var CLICK_SELECTOR = '.snap_buy_now_btn';
  var VISIBILITY_THRESHOLD = 0.5; // BRD 1.2: "viewed" == half the widget on screen
  var POLL_INTERVAL_MS = 400;
  var POLL_MAX_TRIES = 50; // ~20s ceiling, then give up quietly
  var CLEVERTAP_RETRY_MS = 1000;
  var CLEVERTAP_MAX_RETRIES = 3;

  var fired = false;
  var polling = false;
  var observer = null;
  var pollTimer = null;
  var clicks = 0;
  var clicksBound = false;
  var sellingPrice = toPrice(script.getAttribute('data-product-price'));
  var variantId = script.getAttribute('data-product-variant-id') || '';

  function clevertapReady() {
    return typeof clevertap !== 'undefined' &&
      clevertap.event &&
      typeof clevertap.event.push === 'function';
  }

  function loginState() {
    try {
      return localStorage.getItem('kp_customer_id') ? 'logged_in' : 'logged_out';
    } catch (_) {
      return 'logged_out';
    }
  }

  function toPrice(cents) {
    var amount = parseFloat(cents);
    return isFinite(amount) ? amount / 100 : null;
  }

  function eventPayload() {
    var data = {
      product_id: PRODUCT_ID,
      product_name: PRODUCT_NAME,
      login_state: loginState()
    };

    if (variantId) data.product_variant_id = variantId;
    if (sellingPrice !== null) data.product_selling_price = sellingPrice;

    return data;
  }

  // Payload is built by the caller, so a retry sends the state as it was at the
  // moment of the event rather than re-reading it a second later.
  function send(eventName, payload, attempt) {
    if (!clevertapReady()) {
      if (attempt >= CLEVERTAP_MAX_RETRIES) return;
      setTimeout(function () { send(eventName, payload, attempt + 1); }, CLEVERTAP_RETRY_MS);
      return;
    }

    try {
      clevertap.event.push(eventName, payload);
    } catch (_) { /* tracking must never break the page */ }
  }

  function onVisible(widget) {
    if (fired) return;
    fired = true;
    stopObserving();
    send('snapmint_widget_viewed', eventPayload(), 0);
  }

  function onClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var button = target.closest(CLICK_SELECTOR);
    if (!button) return;

    var widget = button.closest(WIDGET_SELECTOR) || document.querySelector(WIDGET_SELECTOR);
    if (!widget) return;

    clicks++;
    send('snapmint_widget_clicked', eventPayload(), 0);
  }

  function bindClicks() {
    if (clicksBound) return;
    clicksBound = true;
    document.addEventListener('click', onClick, true);
  }

  function stopObserving() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function stopPolling() {
    polling = false;
    if (pollTimer) {
      clearTimeout(pollTimer);
      pollTimer = null;
    }
  }

  function observe(widget) {
    if (typeof IntersectionObserver !== 'function') {
      onVisible(widget);
      return;
    }
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          onVisible(widget);
          return;
        }
      }
    }, { threshold: VISIBILITY_THRESHOLD });
    observer.observe(widget);
  }

  function pollForWidget(tries) {
    var widget = document.querySelector(WIDGET_SELECTOR);
    if (widget) {
      stopPolling();
      observe(widget);
      return;
    }
    if (tries >= POLL_MAX_TRIES) {
      stopPolling();
      return;
    }
    pollTimer = setTimeout(function () { pollForWidget(tries + 1); }, POLL_INTERVAL_MS);
  }

  function start() {
    if (polling || fired) return;
    polling = true;
    pollForWidget(0);
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e && e.detail && e.detail.variant;
    if (!variant) return;
    if (variant.id) variantId = String(variant.id);
    var price = toPrice(variant.price);
    if (price !== null) sellingPrice = price;
  });

  bindClicks();

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(start, { timeout: 3000 });
  } else {
    setTimeout(start, 1000);
  }


  window.__wbnSnapmintTracking = {
    state: function () {
      return {
        fired: fired,
        polling: polling,
        observing: !!observer,
        clicks: clicks,
        clicksBound: clicksBound,
        sellingPrice: sellingPrice,
        variantId: variantId
      };
    }
  };
})();
